'use strict';

const jQuery = require('jquery');

const container = require('./../../core/container');

const hide = function(param) {
    if (container.get('prevent-hide-overlay') === true) {
        return;
    }

    jQuery('.cloud-overlay').remove();
    container.get('$siteWrapper').removeClass('blur');
};

module.exports.show = function(config = {}) {
    if (container.get('prevent-hide-overlay') === true) {
        return;
    }

    let $siteWrapper = container.get('$siteWrapper');
    let $overlay = jQuery('<div class="cloud-overlay"></div>');
    let $appender = config.appender || container.get('$siteWrapper');

    hide();
    if (typeof config.classes === 'string') {
        $overlay.addClass(config.classes);
    }

    if (typeof config.onClick === 'function') {
        $overlay.on('click', config.onClick);
    } else {
        $overlay.publish('overlay:click');
    }

    if (config.background === false) {
        $overlay.addClass('no-background');
    }

    if (config['reduce_opacity'] === true) {
        $overlay.addClass('reduce_opacity');
    }

    $appender.append($overlay);

    if (config.blur !== false) {
        $siteWrapper.addClass('blur');
    }
};

module.exports.hide = hide;
